import styled from 'styled-components'
import { Drawer } from 'antd'
import { font } from 'assets/themes/theme-default'

const DrawerStyled = styled(Drawer)`
  .ant-drawer-content {
    border-radius: 16px 16px 0 0;
    font-size: ${font.size.sm};
  }
  & .ant-drawer-title {
    font-size: ${font.size.base};
  }
`
export default DrawerStyled
